export default __webpack_public_path__ + "img/tremors/tremors8_1500.jpg";